import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useContext, useState, useEffect } from 'react';
import { u as useChannelContext, a as isDisabledBecauseFrozen, b as isDisabledBecauseMuted, d as isOperator } from '../../ChannelProvider-5dcbee7b.js';
import MessageInput from '../../ui/MessageInput.js';
import QuoteMessageInput from '../../ui/QuoteMessageInput.js';
import { a as LocalizationContext } from '../../LocalizationContext-a82461b5.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import SuggestedMentionList from './SuggestedMentionList.js';
import { M as MessageInputKeys } from '../../const-3a34a127.js';
import { V as VoiceMessageInputWrapper } from '../../VoiceMessageInputWrapper-43163d7f.js';
import { u as useDirtyGetMentions } from '../../useDirtyGetMentions-dffd4046.js';
import { u as useMediaQueryContext } from '../../MediaQueryContext-d6110905.js';
import '../../UserProfileContext-f3f446d2.js';
import 'prop-types';
import '../../const-72f012b6.js';
import '../../index-ccef08fe.js';
import '../../index-6add7940.js';
import '../../topics-eb548880.js';
import '../../index-579ca9d7.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../compareIds-2e50e905.js';
import '@sendbird/chat/groupChannel';
import '../../uuid-717930b4.js';
import '@sendbird/chat/message';
import '../../consts-fa6ab3c0.js';
import '../../resolvedReplyType-9d00a3db.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../index-6420013c.js';
import '../../stringSet-b60e9529.js';
import 'dompurify';
import '../../consts-b4cb83cf.js';
import '../../ui/Icon.js';
import '../../consts-7693b8d3.js';
import '../../consts-9469111b.js';
import '../../tokenize-c718324d.js';
import '../../index.module-4f1cd64e.js';
import '../../ui/ImageRenderer.js';
import '../../withSendbird.js';
import '../../ui/Avatar.js';
import '../../ThreadProvider-cf357120.js';
import '../../Thread/context/types.js';
import '@sendbird/chat';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../index-fa5b2b8c.js';
import '../../VoiceRecorder/context.js';
import '../../ui/Modal.js';
import 'react-dom';
import '../../index-a9101009.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../index-090cbf21.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ProgressBar.js';
import '../../ui/TextButton.js';
import '../../color-91e43dce.js';
var MessageInputWrapper = function MessageInputWrapper(props, ref) {
  var value = props.value,
    renderFileUploadIcon = props.renderFileUploadIcon,
    renderVoiceMessageIcon = props.renderVoiceMessageIcon,
    renderSendMessageIcon = props.renderSendMessageIcon;
  var propDisabled = props.disabled;
  var _useChannelContext = useChannelContext(),
    currentGroupChannel = _useChannelContext.currentGroupChannel,
    initialized = _useChannelContext.initialized,
    quoteMessage = _useChannelContext.quoteMessage,
    sendMessage = _useChannelContext.sendMessage,
    sendFileMessage = _useChannelContext.sendFileMessage,
    sendVoiceMessage = _useChannelContext.sendVoiceMessage,
    setQuoteMessage = _useChannelContext.setQuoteMessage,
    messageInputRef = _useChannelContext.messageInputRef,
    renderUserMentionItem = _useChannelContext.renderUserMentionItem;
  var globalStore = useSendbirdStateContext();
  var _useMediaQueryContext = useMediaQueryContext(),
    isMobile = _useMediaQueryContext.isMobile;
  var channel = currentGroupChannel;
  var _globalStore$config = globalStore.config,
    isOnline = _globalStore$config.isOnline,
    isMentionEnabled = _globalStore$config.isMentionEnabled,
    userMention = _globalStore$config.userMention,
    isVoiceMessageEnabled = _globalStore$config.isVoiceMessageEnabled,
    logger = _globalStore$config.logger;
  var maxUserMentionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxMentionCount) || 10;
  var maxUserSuggestionCount = (userMention === null || userMention === void 0 ? void 0 : userMention.maxSuggestionCount) || 15;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    mentionNickname = _useState2[0],
    setMentionNickname = _useState2[1]; // todo: set type
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    mentionedUsers = _useState4[0],
    setMentionedUsers = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    mentionedUserIds = _useState6[0],
    setMentionedUserIds = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedUser = _useState8[0],
    setSelectedUser = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    mentionSuggestedUsers = _useState0[0],
    setMentionSuggestedUsers = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    messageInputEvent = _useState10[0],
    setMessageInputEvent = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showVoiceMessageInput = _useState12[0],
    setShowVoiceMessageInput = _useState12[1];
  var disabled = propDisabled || !initialized || isDisabledBecauseFrozen(channel) || isDisabledBecauseMuted(channel) || !isOnline;
  var isOperator$1 = isOperator(channel);
  var isBroadcast = channel === null || channel === void 0 ? void 0 : channel.isBroadcast;
  var displaySuggestedMentionList = isOnline && isMentionEnabled && mentionNickname.length > 0 && !isDisabledBecauseFrozen(channel) && !isDisabledBecauseMuted(channel) && !isBroadcast;

  // Reset when channel changes
  useEffect(function () {
    setMentionNickname('');
    setMentionedUsers([]);
    setMentionedUserIds([]);
    setSelectedUser(null);
    setMentionSuggestedUsers([]);
    setMessageInputEvent(null);
    setShowVoiceMessageInput(false);
  }, [channel === null || channel === void 0 ? void 0 : channel.url]);
  var mentionNodes = useDirtyGetMentions({
    ref: ref || messageInputRef
  }, {
    logger: logger
  });
  var ableMention = (mentionNodes === null || mentionNodes === void 0 ? void 0 : mentionNodes.length) < maxUserMentionCount;
  useEffect(function () {
    setMentionedUsers(mentionedUsers.filter(function (_ref) {
      var userId = _ref.userId;
      var i = mentionedUserIds.indexOf(userId);
      if (i < 0) {
        return false;
      } else {
        mentionedUserIds.splice(i, 1);
        return true;
      }
    }));
  }, [mentionedUserIds]);

  // broadcast channel + not operator
  if (isBroadcast && !isOperator$1) {
    return null;
  }
  // other conditions
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-input-wrapper".concat(showVoiceMessageInput ? '--voice-message' : '')
  }, displaySuggestedMentionList && /*#__PURE__*/React__default.createElement(SuggestedMentionList, {
    targetNickname: mentionNickname,
    inputEvent: messageInputEvent,
    renderUserMentionItem: renderUserMentionItem,
    onUserItemClick: function onUserItemClick(user) {
      if (user) {
        setMentionedUsers([].concat(_toConsumableArray(mentionedUsers), [user]));
      }
      setMentionNickname('');
      setSelectedUser(user);
      setMessageInputEvent(null);
    },
    onFocusItemChange: function onFocusItemChange() {
      setMessageInputEvent(null);
    },
    onFetchUsers: function onFetchUsers(users) {
      setMentionSuggestedUsers(users);
    },
    ableAddMention: ableMention,
    maxMentionCount: maxUserMentionCount,
    maxSuggestionCount: maxUserSuggestionCount
  }), quoteMessage && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message-input-wrapper__quote-message-input"
  }, /*#__PURE__*/React__default.createElement(QuoteMessageInput, {
    replyingMessage: quoteMessage,
    onClose: function onClose() {
      return setQuoteMessage(null);
    }
  })), showVoiceMessageInput ? /*#__PURE__*/React__default.createElement(VoiceMessageInputWrapper, {
    channel: channel,
    onSubmitClick: function onSubmitClick(recordedFile, duration) {
      sendVoiceMessage(recordedFile, duration, quoteMessage);
      setQuoteMessage(null);
      setShowVoiceMessageInput(false);
    },
    onCancelClick: function onCancelClick() {
      setShowVoiceMessageInput(false);
    }
  }) : /*#__PURE__*/React__default.createElement(MessageInput, {
    className: "sendbird-message-input-wrapper__message-input",
    value: value,
    channelUrl: channel === null || channel === void 0 ? void 0 : channel.url,
    mentionSelectedUser: selectedUser,
    isMentionEnabled: isMentionEnabled,
    isVoiceMessageEnabled: isVoiceMessageEnabled,
    onVoiceMessageIconClick: function onVoiceMessageIconClick() {
      setShowVoiceMessageInput(true);
    },
    setMentionedUsers: setMentionedUsers,
    channel: channel,
    placeholder: quoteMessage && stringSet.MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER || isDisabledBecauseFrozen(channel) && stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED || isDisabledBecauseMuted(channel) && (isMobile ? stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED_SHORT : stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED),
    ref: ref || messageInputRef,
    disabled: disabled,
    renderFileUploadIcon: renderFileUploadIcon,
    renderSendMessageIcon: renderSendMessageIcon,
    renderVoiceMessageIcon: renderVoiceMessageIcon,
    onStartTyping: function onStartTyping() {
      channel === null || channel === void 0 ? void 0 : channel.startTyping();
    },
    onSendMessage: function onSendMessage(_ref2) {
      var _channel$endTyping;
      var message = _ref2.message,
        mentionTemplate = _ref2.mentionTemplate;
      sendMessage({
        message: message,
        quoteMessage: quoteMessage,
        mentionedUsers: mentionedUsers,
        mentionTemplate: mentionTemplate
      });
      setMentionNickname('');
      setMentionedUsers([]);
      setQuoteMessage(null);
      channel === null || channel === void 0 ? void 0 : (_channel$endTyping = channel.endTyping) === null || _channel$endTyping === void 0 ? void 0 : _channel$endTyping.call(channel);
    },
    onFileUpload: function onFileUpload(file) {
      sendFileMessage(file, quoteMessage);
      setQuoteMessage(null);
    },
    onUserMentioned: function onUserMentioned(user) {
      if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.userId) === (user === null || user === void 0 ? void 0 : user.userId)) {
        setSelectedUser(null);
        setMentionNickname('');
      }
    },
    onMentionStringChange: function onMentionStringChange(mentionText) {
      setMentionNickname(mentionText);
    },
    onMentionedUserIdsUpdated: function onMentionedUserIdsUpdated(userIds) {
      setMentionedUserIds(userIds);
    },
    onKeyDown: function onKeyDown(e) {
      if (displaySuggestedMentionList && (mentionSuggestedUsers === null || mentionSuggestedUsers === void 0 ? void 0 : mentionSuggestedUsers.length) > 0 && (e.key === MessageInputKeys.Enter && ableMention || e.key === MessageInputKeys.ArrowUp || e.key === MessageInputKeys.ArrowDown)) {
        setMessageInputEvent(e);
        return true;
      }
      return false;
    }
  }));
};
var MessageInputWrapper$1 = /*#__PURE__*/React__default.forwardRef(MessageInputWrapper);
export { MessageInputWrapper$1 as default };